import React, { Fragment, useMemo } from 'react';


// Components

import UniversalInput from '@lib/wrappers/UniversalInput';

// Constants

import { DROPDOWN_OPTIONS } from '@constants/ssap/hhmTypes/dropdownOptions';
import { INPUT_TYPES } from '@constants/inputs/inputTypes';
import { VALIDATION_TYPES } from '@constants/inputs/validationTypes';



const PairsBlock = props => {

    const {
        coverageYear,
        family,
        onFieldChange,
        ...restProps
    } = props;

    const pairsWithFilers = useMemo(
        () => {
            return family.pairs.filter(pair => pair.isPairAccordingToLaw && pair.isAnyOfSpousesFiler);
        },
        [ family.pairs ]
    );

    const getPairs = () => {

        return pairsWithFilers
            .map(pair => {

                const {
                    pairId,
                    spouse1: {
                        spouse1fullName
                    },
                    spouse2: {
                        spouse2fullName,
                    },
                    doSpousesFileTogether,
                    doSpousesFileSeparately,
                    spouseIndexes
                } = pair;

                const getValue = () => doSpousesFileTogether ? 'jointly' : doSpousesFileSeparately ? 'separately' : null;

                return (
                    <Fragment key={pairId}>

                        <UniversalInput
                            legend={{
                                legendText: 'ssap.input.legend.how_spouses_file_taxes',
                                legendTextReplacements: {
                                    spouse1fullName: <strong>{spouse1fullName}</strong>,
                                    spouse2fullName: <strong>{spouse2fullName}</strong>,
                                    coverageYear: <strong>{coverageYear}</strong>
                                }
                            }}
                            label={{
                                labelClass: ['usa-width-one-whole', 'layout--02'],
                                ulClass: ['usa-width-one-whole margin-b-20'],
                                showRequiredIcon: true
                            }}
                            inputData={{
                                isInputRequired: true,
                                type: INPUT_TYPES.RADIO_BUTTONS,
                                classes:['disp-styl-none'],
                                name: 'spousesChoice',
                                value: getValue(),
                                options: DROPDOWN_OPTIONS.FILING_JOINTLY_YES_NO,
                                validationType: VALIDATION_TYPES.CHOSEN,
                                currentData: {},
                                fields: []
                            }}
                            errorClasses = { [ 'margin-l-0' ] }
                            inputActions={{
                                onFieldChange
                            }}
                            indexInArray={spouseIndexes}
                            {...restProps}
                        />

                    </Fragment>
                );
            });
    };

    return pairsWithFilers.length ?

        <div className="subsection">
            {
                getPairs()
            }
        </div> : null;
};

export default PairsBlock;
